<div *ngIf="!prj?.detalleConstruccionItem">
    <div class="text-900 font-semibold text-xl">(0) Detalles de construcción</div>
</div>
<div *ngIf="prj!.detalleConstruccionItem!">
    <label class="text-900 font-semibold text-xl" [pTooltip]="'Detalles de construcción registrados previamente'">
        ({{ prj!.detalleConstruccionItem?.length == null ? 0 : prj!.detalleConstruccionItem?.length }}) Detalles de construcción
    </label>
    <div class="field">
        <p-table [value]="prj!.detalleConstruccionItem!"
                 [scrollable]="true" scrollHeight="250px"
                 styleClass="p-datatable-striped p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th>Descripción</th>
                    <th>Nivel</th>
                    <th>Cantidad</th>
                    <th>Fase</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detalleconst>
                <tr>
                    <td>{{ detalleconst.descripcion }}</td>
                    <td>{{ detalleconst.nivel }}</td>
                    <td>{{ detalleconst.cantidad }}</td>
                    <td>{{ detalleconst.fase }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
